import {Injectable} from '@angular/core';
import {EntityState, SignalEntityStore} from 'src/app/modules/shared/state/signal-entity.store';
import {ClaimDetails} from 'src/app/modules/shared/models/claim.model';

export interface ClaimsState extends EntityState<ClaimDetails> {}

@Injectable({providedIn: 'root'})
export class ClaimsStore extends SignalEntityStore<ClaimDetails, ClaimsState> {
    constructor(){
        super({name: 'claims', idKey: 'claim_id'});
    }
}
